export default function isNull(input: any): boolean{
    return input == null || input == '' || (typeof input === 'object' && Object.keys(input).length === 0)
}